import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=6e267b5e&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=6e267b5e&prod&lang=scss&scoped=true"
import style1 from "./BottomNav.vue?vue&type=style&index=1&id=6e267b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e267b5e",
  null
  
)

export default component.exports